var exports = {
  "wV": "detailRow__N20jtv",
  "M": "detailLabel__6umMhi",
  "XL": "detailIcon__LJBtwa",
  "zL": "detailValue__xbT2C7",
  "kL": "container__l7QHdp",
  "kQ": "bodyContent__aZAmMh",
  "iS": "bodyContentWithStatus__VusAqF",
  "v_": "bodyContentNoStatus__mUlYhM",
};

module.exports = exports;
